import React, { useState } from "react";
import { getAuth, sendPasswordResetEmail } from "firebase/auth";
import { db } from "../../../firebase";
import { collection, query, where, getDocs } from "firebase/firestore";
import { Mail } from "lucide-react";

export default function CorporateForgotPassword() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(false);

  const handleReset = async (e) => {
    e.preventDefault();
    setStatus("");
    setLoading(true);

    try {
      if (!email.includes("@")) {
        setStatus("Lütfen geçerli bir e-posta adresi girin.");
        setLoading(false);
        return;
      }

      // 🔍 Companies koleksiyonunda kontrol et
      const q = query(collection(db, "companies"), where("email", "==", email));
      const snapshot = await getDocs(q);

      if (snapshot.empty) {
        setStatus("Bu e-posta adresine ait bir şirket bulunamadı.");
        setLoading(false);
        return;
      }

      // 📩 Firebase Auth üzerinden sıfırlama maili gönder
      const auth = getAuth();
      await sendPasswordResetEmail(auth, email);

      setStatus(
        "Şifre sıfırlama bağlantısı e-posta adresinize gönderildi. Lütfen gelen kutunuzu kontrol edin."
      );
    } catch (error) {
      console.error("Şifre sıfırlama hatası:", error);
      if (error.code === "auth/user-not-found") {
        setStatus("Bu e-posta adresine ait hesap bulunamadı.");
      } else {
        setStatus("Bir hata oluştu. Lütfen tekrar deneyin.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <h2 style={styles.title}>Şifremi Unuttum</h2>
        <p style={styles.subtitle}>
          Kayıtlı kurumsal e-posta adresinizi girin. Size şifre sıfırlama bağlantısı göndereceğiz.
        </p>

        <form onSubmit={handleReset} style={styles.form}>
          <div style={styles.inputGroup}>
            <label style={styles.label}>Kurumsal E-posta</label>
            <div style={styles.inputWrapper}>
              <Mail size={20} color="#555" style={styles.icon} />
              <input
                type="email"
                name="email"
                placeholder="info@sirketiniz.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                style={styles.input}
              />
            </div>
          </div>

          {status && (
            <p
              style={{
                ...styles.status,
                color: status.includes("gönderildi") ? "#15803d" : "#dc2626",
              }}
            >
              {status}
            </p>
          )}

          <button
            type="submit"
            disabled={loading}
            style={{
              ...styles.button,
              backgroundColor: loading ? "#8ba3d9" : "#001E78",
            }}
          >
            {loading ? "Gönderiliyor..." : "Sıfırlama Bağlantısı Gönder"}
          </button>

          <div style={styles.links}>
            <a href="/signup_corporate" style={styles.link}>
              Hesap Oluştur
            </a>
          </div>
        </form>
      </div>
    </div>
  );
}

const styles = {
  page: {
    backgroundColor: "#fff",
    minHeight: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "20px",
  },
  card: {
    backgroundColor: "#ffffff",
    borderRadius: "16px",
    boxShadow: "0 8px 24px rgba(0, 0, 0, 0.1)",
    width: "100%",
    maxWidth: "420px",
    padding: "45px 40px",
    textAlign: "center",
  },
  title: {
    fontSize: "26px",
    fontWeight: "600",
    color: "#001E78",
    marginBottom: "10px",
    letterSpacing: "0.3px",
  },
  subtitle: {
    fontSize: "14px",
    color: "#555",
    marginBottom: "30px",
    lineHeight: 1.6,
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: "22px",
  },
  inputGroup: {
    textAlign: "left",
  },
  label: {
    display: "block",
    marginBottom: "6px",
    fontSize: "14px",
    fontWeight: "500",
    color: "#444",
  },
  inputWrapper: {
    position: "relative",
  },
  icon: {
    position: "absolute",
    top: "50%",
    left: "12px",
    transform: "translateY(-50%)",
  },
  input: {
    width: "87%",
    padding: "12px 12px 12px 40px",
    fontSize: "15px",
    borderRadius: "8px",
    border: "1px solid #ccc",
    outline: "none",
    transition: "all 0.2s ease",
  },
  button: {
    width: "100%",
    padding: "12px 0",
    fontSize: "16px",
    fontWeight: "500",
    border: "none",
    borderRadius: "8px",
    color: "#fff",
    cursor: "pointer",
    transition: "all 0.3s ease",
  },
  status: {
    fontSize: "14px",
    textAlign: "center",
    marginTop: "-8px",
    fontWeight: "500",
  },
  links: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "10px",
    marginTop: "25px",
  },
  link: {
    fontSize: "14px",
    color: "#001E78",
    textDecoration: "none",
    transition: "color 0.2s",
  },
};
